// src/utils/apiClient.js
import axios from "axios";

// Define API base URL as a constant
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

// Axios instance with default headers and interceptors
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests and handle token expiration
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.config?.url !== "/login") {
      localStorage.removeItem("token");
      localStorage.removeItem("organization_id");
      localStorage.removeItem("company");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;